<script lang="ts" setup>
const { template } = storeToRefs(useTemplateStore());
const { supportsRsvp } = usePackageCapabilities();

const isRsvpVisible = computed(() => template.value.rsvp.enabled && supportsRsvp.value);
</script>

<template>
  <div class="h-safe-min-screen flex flex-col relative items-center py-section-alt overflow-hidden">
    <!-- Mobile Assets -->
    <LazyPGroupAssetsMobile />

    <!-- Desktop Assets -->
    <LazyPGroupAssetsDesktop />

    <!-- Contents -->
    <PRsvp
      v-if="isRsvpVisible"
    />
    <PDressCode
      v-if="template.dress_code.enabled"
    />
    <PGift
      v-if="template.gift.enabled"
    />
  </div>
</template>

<style lang="css" scoped>
:deep(.smooth-wave-flower-right) {
  --rot: -0.2deg;
  --x: -4px;
  --y: 12px;
  --breath: 0.012;

  transform-origin: bottom left;
  will-change: translate, rotate, scale, filter;

  translate: 0 0;
  rotate: 0deg;
  scale: 1;

  animation:
    alive-sway 3.5s ease-in-out infinite alternate,
    alive-breath 6.5s ease-in-out infinite;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.16));
}
</style>
